import { Alert, Box, Button, Card, CircularProgress, Container, Divider, FormControl, FormControlLabel, FormLabel, Grid, IconButton, Input, List, ListItem, ListItemButton, ListItemText, Radio, RadioGroup, Snackbar, TextField, Typography, useTheme } from "@mui/material";
import { Fragment, useEffect, useState } from "react";
import { connect, useDispatch } from "react-redux";
import { authActions } from "../../store/reducer/auth-reducer";
import { Link, useNavigate, useOutletContext } from "react-router-dom";
import CloseIcon from '@mui/icons-material/Close';
import AlertBar from "../../components/AlertBar";
import bankdetails from "../profile/bankdetails";
import GooglePayButton from '@google-pay/button-react';
import axios from 'axios'
import { homePageActions } from "../../store/reducer/home";
import { ArrowDownward, ContentCopy, Refresh } from "@mui/icons-material";
import { get, isEmpty } from "lodash";


const ManualPayment = ({
    isLoginLoading,
    adminPGSetupSuccesss,
    adminPGSetupFailed,
    adminPaymentData,
    userPaymentUploadSuccess,
    userPaymentUploadFailed,
    adminApprovalSuccess,
    adminApprovalFailed
}: any) => {
    const outletData:any = useOutletContext();
    const userDataSession: any = localStorage.getItem('userData');
    const finalData = JSON.parse(userDataSession)
    const theme = useTheme();
    const dispatch = useDispatch();
    const [fileString, setFileString] = useState<any>('');
    const [qrDetails, setQrDetails] = useState<any>({});
    const [errorMessage, setErrorMessage] = useState<any>({ status: false, message: '', severity: '', inputName: '' })
    const [points, setPoints] = useState<any>('');

    const handleClose = (event: React.SyntheticEvent | Event, reason?: string) => {
        if (reason === 'clickaway') {
            return;
        }

        setErrorMessage({ status: false, message: "", severity: "", inputName: '' })
    };


    useEffect(() => {
        const payload: any = {
            user_id: finalData.user_id,
            reqtype: 'fetch'
        };
        dispatch(authActions.adminManualPayInfReq(payload))
        
    }, [])

    console.log(outletData.walletBalance.min_withdrawal);

    useEffect(() => {
        if (adminPaymentData.length) {
            setQrDetails(adminPaymentData[0])
        } else {
            setQrDetails([]);
        }

    }, [adminPaymentData])

    function getBase64(file: any, cb: any) {
        let reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = function () {
            cb(reader.result)
        };
        reader.onerror = function (error) {
            console.log('Error: ', error);
        };
    }

    const handleFileChange = (e: any) => {       
        let file = e.target.files[0];
        setFileString('');       
        let filename = file.name;        
        let _ext = filename.split('.').pop();
        if (file) {
            if (_ext.toLowerCase() === 'jpg' || _ext.toLowerCase() === 'png' || _ext.toLowerCase() === 'jpeg') {
                const reader = new FileReader();
                reader.onload = _handleReaderLoaded.bind(this);
                reader.readAsBinaryString(file);
            } else {
                setErrorMessage({ status: true, message: "JPEG & PNG is supported.", severity: "warning", inputName: '' })
            }
        } else {
            setErrorMessage({ status: true, message: "Please enter valid file.", severity: "warning", inputName: '' })
        }
    }



    const _handleReaderLoaded = (e: any) => {
        console.log("file uploaded 2: ", e);
        let binaryString = e.target.result;
        setFileString(btoa(binaryString))
    };

    const ontextChange = (e: any) => {
        setPoints(e.target.value)
    }

    const handleSubmit = () => {
        if(fileString===''){
            setErrorMessage({ status: true, message: "Please upload payment receipt screenshot.", severity: "warning", inputName: '' })
        } else if(points===''){
            setErrorMessage({ status: true, message: "Please enter paid amount.", severity: "warning", inputName: '' })
        } else {
            const payload: any = {
                user_id: finalData.user_id,
                order_id: 'ORD' + Date.now(),
                json_req: fileString,
                amount: points,
                reason: 'Payment initiated',
                user_details: JSON.stringify(finalData),
            };            
            dispatch(authActions.userPaymentReq(payload))
        }       
    }

    useEffect(() => {
        if (userPaymentUploadSuccess) {
            setErrorMessage({ status: true, message: "Submitted successfully, please reload the page after sometime.", severity: "success", inputName: '' })
        }

        if (userPaymentUploadFailed) {
            setErrorMessage({ status: true, message: "Failed please try agian", severity: "warning", inputName: '' })
        }
    }, [
        userPaymentUploadSuccess,
        userPaymentUploadFailed,
    ])
    return (<Container sx={{ 
        backgroundColor: theme.palette.background.default,
        minHeight: '100vh',
        paddingTop: { xs: '20px', sm: '25px', md: '30px' },
        paddingBottom: { xs: '80px', sm: '80px', md: '30px' },
    }}>
        {isLoginLoading ? <div style={{ width: '100%', height: '30vh', display: 'flex', justifyContent: 'center', alignItems: 'center', flexDirection: 'row' }}> <CircularProgress sx={{ color: theme.palette.primary.main }} /> </div> :
            <Grid container display={'flex'} justifyContent={'center'} mb={20}>
                <AlertBar handleClose={handleClose} errorMessage={errorMessage} />
                <Grid xs={12} lg={12} md={12} sm={12} sx={{ display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
                    <Card sx={{ 
                        display: 'flex', 
                        flexDirection: 'column', 
                        border: `1px solid ${theme.palette.divider}`,
                        boxShadow: '0 4px 20px rgba(74, 144, 226, 0.12)',
                        borderRadius: '24px',
                        backgroundColor: theme.palette.background.paper,
                        alignItems: "center", 
                        justifyContent: 'center', 
                        gap: 2, 
                        padding: { xs: '20px', sm: '24px', md: '28px' },
                        position: 'relative',
                        overflow: 'hidden',
                        '&::before': {
                            content: '""',
                            position: 'absolute',
                            top: 0,
                            left: 0,
                            right: 0,
                            height: '4px',
                            background: `linear-gradient(90deg, ${theme.palette.primary.main} 0%, ${theme.palette.secondary.main} 100%)`,
                            opacity: 0.8,
                        },
                        transition: 'all 0.3s ease',
                    }}>

                        {/* {qrDetails['upi_id'] != null && <Typography>UPI ID : {qrDetails['upi_id']}</Typography>}  */}
                        <Grid container sx={{ display: 'flex', flexDirection: 'row' }}>
                            <Grid xs={12} sx={{display:'flex', justifyContent:'center', flexDirection:'column'}}>
                                <Box sx={{display:'flex', justifyContent:'center', alignItems:'center', flexDirection:'column', textAlign:'center'}}>
                                <Typography sx={{
                                    backgroundColor: theme.palette.mode === 'light' 
                                        ? 'rgba(255, 107, 107, 0.1)' 
                                        : 'rgba(255, 107, 107, 0.2)',
                                    width: '100%',
                                    borderRadius: '12px',
                                    padding: '10px 16px',
                                    color: theme.palette.error.main,
                                    fontFamily: 'Poppins',
                                    fontWeight: 600,
                                    fontSize: '0.95rem',
                                    border: `1px solid ${theme.palette.error.light}`,
                                    boxShadow: '0 2px 8px rgba(255, 107, 107, 0.15)',
                                }}>
                                    *Min deposit amount is: ₹{get(outletData,'walletBalance.min_deposite',0)}
                                </Typography>
                                <Typography sx={{
                                    backgroundColor: theme.palette.mode === 'light' 
                                        ? 'rgba(82, 201, 162, 0.1)' 
                                        : 'rgba(82, 201, 162, 0.2)',
                                    borderRadius: '12px',
                                    padding: '12px 16px',
                                    marginTop: '10px',
                                        width: '100%',
                                    fontSize: '0.95rem',
                                    fontFamily: 'Poppins',
                                    fontWeight: 500,
                                    color: theme.palette.text.primary,
                                    border: `1px solid ${theme.palette.success.light}`,
                                    boxShadow: '0 2px 8px rgba(82, 201, 162, 0.15)',
                                    lineHeight: 1.6,
                                }}>
                                    Pay and send the Screenshot with registered mobile number. <br/> Scan & Pay here
                                </Typography>
                                <ArrowDownward sx={{ 
                                    color: theme.palette.primary.main,
                                    marginTop: '10px',
                                    fontSize: '2rem',
                                    animation: 'bounce 2s infinite',
                                    '@keyframes bounce': {
                                        '0%, 100%': {
                                            transform: 'translateY(0)',
                                        },
                                        '50%': {
                                            transform: 'translateY(10px)',
                                        },
                                    },
                                }} />
                                </Box>
                                
                                {/* <Typography>{qrDetails.upi_id}</Typography> */}
                                
                                <Box sx={{
                                    height: '250px', 
                                    width: '100%',
                                    maxWidth: '300px',
                                    marginTop: '20px',
                                    marginLeft: 'auto',
                                    marginRight: 'auto',
                                    padding: '20px',
                                    backgroundColor: theme.palette.background.default,
                                    borderRadius: '16px',
                                    border: `2px dashed ${theme.palette.divider}`,
                                    display: 'flex',
                                    justifyContent: 'center',
                                    alignItems: 'center',
                                    boxShadow: '0 4px 12px rgba(74, 144, 226, 0.08)',
                                    transition: 'all 0.3s ease',
                                    '&:hover': {
                                        borderColor: theme.palette.primary.main,
                                        boxShadow: '0 6px 20px rgba(74, 144, 226, 0.15)',
                                    },
                                    img: {
                                        height: '100%',
                                        width: '100%',
                                        objectFit: 'contain',
                                        borderRadius: '12px',
                                    }, 
                                }}> 
                                    {qrDetails['qr_image'] != null && <img src={`data:image;base64,${qrDetails['qr_image']}`} />} 
                                </Box>
                                <Box sx={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    gap: 1,
                                    marginTop: '15px',
                                    padding: '12px 20px',
                                    backgroundColor: theme.palette.mode === 'light' 
                                        ? 'rgba(74, 144, 226, 0.1)' 
                                        : 'rgba(74, 144, 226, 0.2)',
                                    borderRadius: '12px',
                                    border: `1px solid ${theme.palette.primary.light}`,
                                }}>
                                    <Typography sx={{
                                        textAlign: 'center',
                                        fontFamily: 'Poppins',
                                        fontWeight: 600,
                                        fontSize: '1rem',
                                        color: theme.palette.primary.main,
                                        letterSpacing: '0.5px',
                                    }}>
                                        {qrDetails.upi_id}
                                    </Typography>
                                    <IconButton
                                        onClick={() => { 
                                            navigator.clipboard.writeText(qrDetails.upi_id); 
                                            setErrorMessage({ status: true, message: "Copied!!", severity: "success", inputName: '' }) 
                                        }}
                                        sx={{
                                            color: theme.palette.primary.main,
                                            padding: '4px',
                                            '&:hover': {
                                                backgroundColor: 'rgba(74, 144, 226, 0.2)',
                                                transform: 'scale(1.1)',
                                            },
                                            transition: 'all 0.2s ease',
                                        }}
                                    >
                                        <ContentCopy sx={{ fontSize: '18px' }} />
                                    </IconButton>
                                </Box>
                            </Grid>
                            <Grid xs={12}>
                                <FormControl sx={{ display: 'flex', width: '100%' }}>
                                    {/* <FormLabel sx={{ marginTop: '15px', marginBottom: '5px', color: '#f7ae2b' }}>Upload Screenshot</FormLabel> */}
                                    {/* <TextField type="file" onChange={handleFileChange} name='image' id="file" /> */}
                                    <Button
                                        variant="outlined"
                                        component="label"
                                        onChange={handleFileChange}
                                        sx={{
                                            marginTop: '15px',
                                            minHeight: '100px',
                                            backgroundColor: theme.palette.mode === 'light' 
                                                ? 'rgba(74, 144, 226, 0.05)' 
                                                : 'rgba(74, 144, 226, 0.1)',
                                            border: `2px dashed ${fileString ? theme.palette.success.main : theme.palette.primary.main}`,
                                            borderRadius: '16px',
                                            color: fileString ? theme.palette.success.main : theme.palette.primary.main,
                                            fontWeight: 600,
                                            fontFamily: 'Poppins',
                                            fontSize: '1rem',
                                            display: 'flex',
                                            flexDirection: 'column',
                                            justifyContent: 'center',
                                            alignItems: 'center',                                            
                                            gap: 1,
                                            padding: '20px',
                                            transition: 'all 0.3s ease',
                                            '&:hover': { 
                                                backgroundColor: theme.palette.mode === 'light' 
                                                    ? 'rgba(74, 144, 226, 0.1)' 
                                                    : 'rgba(74, 144, 226, 0.15)',
                                                borderColor: theme.palette.primary.dark,
                                                transform: 'translateY(-2px)',
                                                boxShadow: '0 4px 12px rgba(74, 144, 226, 0.2)',
                                            },
                                        }}
                                    >
                                        <Typography sx={{ fontFamily: 'Poppins', fontWeight: 600, fontSize: '1rem' }}>
                                            📷 Upload Payment Screenshot
                                        </Typography>
                                        <Typography sx={{ 
                                            fontSize: '0.85rem',
                                            fontFamily: 'Poppins',
                                            opacity: 0.8,
                                            color: fileString ? theme.palette.success.main : theme.palette.text.secondary,
                                        }}>
                                            {fileString != '' ? '✓ 1 file selected' : 'No files selected (JPG, PNG, JPEG)'}
                                        </Typography>
                                        <input
                                            name='image' id="file"
                                            type="file"
                                            accept=".jpg,.jpeg,.png"
                                            hidden
                                        />
                                    </Button>

                                    {/* <FormLabel sx={{ marginTop: '15px', marginBottom: '5px', color: '#f7ae2b' }}>Paid Amount?</FormLabel> */}
                                    <TextField 
                                        placeholder="Enter total paid amount" 
                                        label="Paid Amount"
                                        value={points}
                                        sx={{ 
                                            marginTop: '15px', 
                                            width: "100%",
                                            '& .MuiOutlinedInput-root': {
                                                '& fieldset': {
                                                    borderColor: theme.palette.divider,
                                                },
                                                '&:hover fieldset': {
                                                    borderColor: theme.palette.primary.main,
                                                },
                                                '&.Mui-focused fieldset': {
                                                    borderColor: theme.palette.primary.main,
                                                    borderWidth: '2px',
                                                },
                                            },
                                            '& .MuiInputLabel-root.Mui-focused': {
                                                color: theme.palette.primary.main,
                                            },
                                            '& .MuiInputBase-input': {
                                                fontFamily: 'Poppins',
                                                fontSize: '1rem',
                                            },
                                        }}  
                                        type="number" 
                                        onChange={ontextChange} 
                                        name='points' 
                                    />

                                    <Button  
                                        variant="contained" 
                                        sx={{ 
                                            width: "100%", 
                                            marginTop: '20px',
                                            background: `linear-gradient(135deg, ${theme.palette.primary.main} 0%, ${theme.palette.secondary.main} 100%)`,
                                            color: '#FFFFFF',
                                            fontWeight: 600,
                                            fontFamily: 'Poppins',
                                            padding: '14px 24px',
                                            borderRadius: '12px',
                                            fontSize: '1.1rem',
                                            boxShadow: '0 4px 15px rgba(74, 144, 226, 0.3)',
                                            textTransform: 'none',
                                            '&:hover': { 
                                                background: `linear-gradient(135deg, ${theme.palette.primary.dark} 0%, ${theme.palette.secondary.dark} 100%)`,
                                                transform: 'translateY(-2px)',
                                                boxShadow: '0 6px 20px rgba(74, 144, 226, 0.4)',
                                            },
                                            transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
                                        }}  
                                        onClick={handleSubmit}
                                    >
                                        Request to Add Point
                                    </Button>
                                </FormControl>
                            </Grid>
                        </Grid>
                    </Card>
                </Grid>
            </Grid>}
    </Container>);
}


const mapStateToProps = (state: any) => ({
    isLoginLoading: state.authentication.isLoginLoading,
    adminPGSetupSuccesss: state.authentication.adminPGSetupSuccesss,
    adminPGSetupFailed: state.authentication.adminPGSetupFailed,
    adminPaymentData: state.authentication.adminPaymentData,
    userPaymentUploadSuccess: state.authentication.userPaymentUploadSuccess,
    userPaymentUploadFailed: state.authentication.userPaymentUploadFailed,
    adminApprovalSuccess: state.authentication.adminApprovalSuccess,
    adminApprovalFailed: state.authentication.adminApprovalFailed,
})


export default connect(mapStateToProps)(ManualPayment);